import { useEffect, useRef } from 'react';

export function useSyncUrlParam(paramName, callback, options = { enabled: true}) {
    const hasRun = useRef(false);

    useEffect(() => {
        if (hasRun.current || !options.enabled) return;

        const urlParams = new URLSearchParams(window.location.search);
        const paramValue = urlParams.get(paramName);
        if (!paramValue) {
            hasRun.current = true;
            return;
        };

        callback(paramValue);
        hasRun.current = true;
    }, [paramName, callback, options.enabled]);
}